import Rectangle from "./Rectangle";
import Circle from "./Circle";
import Length from "./Length";
import AbstractShape from "./AbstractShape";

export default class Heart extends AbstractShape {
	static NAME = "heart";

	constructor( height ) {
		super();

		this.height = height;
	}

	get_name() {
		return Heart.NAME;
	}

	get_enclosing_rectangle() {
		const a = this.get_rectangle_side().in_mm();
		const b = ( Math.sqrt( 2 ) / 2 + 1 ) * a;
		return new Rectangle( this.height, new Length( b ) );
	}

	get_rectangle_side() //https://rechneronline.de/pi/heart.php.
	{
		const h           = this.height.in_mm();
		const side_length = h / (
			3 / 4 * Math.sqrt( 2 ) + 1 / 2
		);
		return new Length( side_length );
	}

	get_area() //Two half circles on the top gives us one whole.
	{
		const side_length = this.get_rectangle_side();
		const rectangle   = new Rectangle( side_length, side_length );
		const circle      = new Circle( side_length );
		return rectangle.get_area().add( circle.get_area() );
	}

	get_circumference() //Two half circles on the top gives us one whole.
	//The rectangle circumference only counts half, because the other half is inside the shape.
	{
		const side_length = this.get_rectangle_side();
		const rectangle   = new Rectangle( side_length, side_length );
		const circle      = new Circle( side_length );
		return rectangle.get_circumference().divide( 2 ).add( circle.get_circumference() );
	}

	get_height() {
		return this.height;
	}

	get_maximum_dimensions( maximum_rectangle ) //The heart width is the limiting factor, so calculate the height from the maximum width.
	{
		const shortest_side = maximum_rectangle.get_shortest_side();
		const b             = shortest_side.in_mm();
		const a             = b / (
			Math.sqrt( 2 ) / 2 + 1
		);
		const h             = a * (
			3 / 4 * Math.sqrt( 2 ) + 1 / 2
		);
		return {
			height: new Length( h )
		};
	}

	get_dimension_keys() {
		return [ "height" ];
	}

	get_modifier_keys() {
		return [];
	}

	serialize_primitives() {
		return {
			height: this.height.in_mm()
		};
	}

	static deserialize_primitives( primitives ) {
		return new Heart( new Length( primitives.height ) );
	}

}
